export default {
    alertRecord: function(state) {
        return state.alertRecord
    },
}
